import { lazy } from "react";
import { RouteObject } from "react-router-dom";

// Announcements routes
const ViewAnnouncementsAndRemindersPage = lazy(
  () => import("@/shared/announcements/pages/announcement-and-reminders-list")
);
const AnnouncementDetailsPage = lazy(
  () => import("@/shared/announcements/pages/announcement-details")
);
const ReminderDetailsPage = lazy(
  () => import("@/shared/announcements/pages/reminder-details")
);
export const announcementsRoutes: RouteObject[] = [
  {
    path: "/announcements",
    element: (
      <ViewAnnouncementsAndRemindersPage isAdmin={false} isReminders={false} />
    ),
  },
  {
    path: "/announcements/:id",
    element: <AnnouncementDetailsPage />,
  },
  {
    path: "/reminders/:id",
    element: <ReminderDetailsPage />,
  },
];
